import { Helmet } from 'react-helmet-async';
import { useSiteData } from '@/hooks/useSiteData';
import { Header } from '@/components/layout/Header.tsx';
import { Hero } from '@/components/sections/Hero.tsx';
import { ServicesIntroduction } from '@/components/sections/ServicesIntroduction.tsx';
import { AutoPaintingSection } from '@/components/sections/AutoPaintingSection.tsx';
import { TrustedWorkSection } from '@/components/sections/TrustedWorkSection.tsx';
import { TestimonialsSection } from '@/components/sections/TestimonialsSection.tsx';
import { Footer } from '@/components/layout/Footer.tsx';
import heroData from '@/data/hero.json';
import servicesIntroData from '@/data/services-introduction.json';
import autoPaintingData from '@/data/auto-painting-section.json';
import trustedWorkData from '@/data/trusted-work-section.json';
import testimonialsData from '@/data/testimonials.json';
import footerData from '@/data/footer.json';

export function Index() {
  const { siteData } = useSiteData();

  return (
    <>
      <Helmet>
        <title>{siteData.title}</title>
        <meta name="description" content={siteData.description} />
        <meta name="keywords" content={siteData.keywords} />
        
        {/* Open Graph tags */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.allaroundautobody.com/" />
        <meta property="og:title" content={siteData.title} />
        <meta property="og:description" content={siteData.description} />
        <meta property="og:image" content="https://lirp.cdn-website.com/08c2665d/dms3rep/multi/opt/NEWLOGOLOVE-1920w.JPG" />
        
        {/* Twitter Card tags */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={siteData.title} />
        <meta name="twitter:description" content={siteData.description} />
        <meta name="twitter:image" content="https://lirp.cdn-website.com/08c2665d/dms3rep/multi/opt/NEWLOGOLOVE-1920w.JPG" />
        
        <link 
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&family=Open+Sans:wght@300;400;500;600;700;800&family=Lato:wght@100;300;400;700;900&display=swap" 
          rel="stylesheet" 
        />
      </Helmet>
      
      <div className="min-h-screen">
        <Header />
        
        <Hero
          title={heroData.title}
          buttonText={heroData.buttonText}
          buttonHref={heroData.buttonHref}
          backgroundImage={heroData.backgroundImage}
        />
        
        <ServicesIntroduction
          content={servicesIntroData.content}
          phoneNumber={servicesIntroData.phoneNumber}
        />
        
        <AutoPaintingSection
          title={autoPaintingData.title}
          content={autoPaintingData.content}
          imageUrl={autoPaintingData.imageUrl}
          imageAlt={autoPaintingData.imageAlt}
        />
        
        <TrustedWorkSection
          title={trustedWorkData.title}
          description={trustedWorkData.description}
          callToAction={trustedWorkData.callToAction}
          phoneNumber={trustedWorkData.phoneNumber}
          beforeImage={trustedWorkData.beforeImage}
          afterImage={trustedWorkData.afterImage}
          beforeImageAlt={trustedWorkData.beforeImageAlt}
          afterImageAlt={trustedWorkData.afterImageAlt}
        />
        
        <TestimonialsSection
          rating={testimonialsData.rating}
          totalReviews={testimonialsData.totalReviews}
          title={testimonialsData.title}
          testimonials={testimonialsData.testimonials}
        />
        
        <Footer data={footerData} />
      </div>
    </>
  );
}